import { AiFillCloseCircle, AiFillEye } from "react-icons/ai";

const CampaignActionBtns = ({
    adData,
    navigate,
    setSelectedAd,
    handleDeleteModal
}) => {

    const handleDeleteBtn = () => {
        handleDeleteModal();
        setSelectedAd(adData)
    };

    return (
        <div className="flex items-center">
            <button onClick={() => navigate(`/ads-management/${adData?._id}`)}><AiFillEye className='w-4 md:w-6 h-4 md:h-6 text-ezGreen' /></button>
            <button onClick={handleDeleteBtn}><AiFillCloseCircle className='ml-2 w-3 md:w-5 h-3 md:h-5 text-ezRed' /></button>
        </div>
    );
};

export default CampaignActionBtns;